import React from "react";
import {BrowserRouter,Route} from 'react-router-dom';
import Home from './Home';
import Filter from "./Filter";
import filter2 from "./filter2";
import Details from "./Details"
//import H1 from "./H1";
import Head from "./Header";
function Router(){
  return(
    <BrowserRouter>
   <Route exact path='/'component={Home}/>
    <Route path="/filter"component={Filter}/>
    <Route path="/details"component={Details}/>
    <Route path="/filter2"component={filter2}/>
    {/* <Route path="/H1"component={H1}/> */}
    <Route path="/Head"component={Head}/>
    </BrowserRouter>
  )
}
export default Router;



